export default "__VITE_ASSET__BDIL1PsU__"